<template>
    <div>
        <div>
            <div id="warningNote" data-aos="fade-up" data-aos-delay="50">
                <div class="box-content">
                    <div class="note text-danger">
                        <table>
                            <tr>
                                <td>
                                    <div class="note-icon"><i class="mdi mdi-alert-circle-outline"></i></div>
                                </td>
                                <td>
                                    <label id="systemNote" class="text-uppercase my-2">
                                        Please be aware that both Bradford White and our competitor's model specifications and dimensions are subject to change without notice. All changes may not be accounted for in the RightSpec<sup>&reg;</sup> Cross Reference Guide.
                                    </label>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="pb-4">
            <div id="warningNote" data-aos="fade-up" data-aos-delay="50">
                <div class="box-content">
                    <div class="note note-info">
                        <table>
                            <tr>
                                <td>
                                    <div class="note-icon"><i class="mdi mdi-help-circle-outline"></i></div>
                                </td>
                                <td>
                                    <label id="systemNote" class="my-2">
                                        Can't find the competitive brand/model or an older Bradford White model you were looking for? If so, please reach out to the Bradford White Product Department at <a class="font-weight-bold" href="mailto: products@bradfordwhite.com">products@bradfordwhite.com</a> or call <span class="font-weight-bold text-primary">844-235-4958</span> for assistance.
                                        Be sure to provide as much information as possible from the <a id="popover-guide" class="keyinfo font-weight-bold">Key Info to Know</a> guide.
                                    </label>
                                    <b-popover target="popover-guide"
                                               placement="auto"
                                               triggers="hover"
                                               variant="info"
                                               custom-class="shadow-sm">
                                        <template v-slot:title>
                                            <span class="text-md">Key Info to Know</span>
                                        </template>
                                        <ul class="list-unstyled">
                                            <li>Residential or Commercial?</li>
                                            <li>
                                                Gas or Electric?
                                                <ul>
                                                    <li>
                                                        If Gas, Natural or LP?
                                                    </li>
                                                    <li>
                                                        Vent style (gas only)?
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>Gallons?</li>
                                            <li>
                                                Input?
                                                <ul>
                                                    <li>Gas = BTU/Hr</li>
                                                    <li>Electric = kW</li>
                                                </ul>
                                            </li>
                                            <li>Any critical dimensions?</li>
                                            <li>ASME construction?</li>
                                            <li>Fixture count and usage patterns?</li>
                                            <li>New construction or redesign?</li>
                                        </ul>
                                    </b-popover>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'warning-notes'
    }
</script>
<style scoped lang="scss">
    @import '~@/styles/scss/variables';

    .keyinfo {
        color: $primary !important;
        cursor: pointer;
    }

        .keyinfo:hover {
            color: $primary-hover !important;
        }
</style>
